import type { ElementType } from "react";
import { USER_ROLES } from "../app/app.constants";
import DashboardIcon from "../layouts/_icons/DashboardIcon";
import MyCoursesIcon from "../layouts/_icons/MyCoursesIcon";
import Campaign from "../pages/Admin/Campaign/Campaign";
import ManageCampaign from "../pages/Admin/Campaign/ManageCampaign";
import Dashboard from "../pages/Admin/Dashboard/Dashboard";
import ManageContent from "../pages/Admin/Dashboard/ManageContent";
import ManageCourse from "../pages/Admin/Dashboard/ManageCourse";
import ManageHighlights from "../pages/Admin/Dashboard/ManageHighlights";
import ManageQuizDetails from "../pages/Admin/ManageQuiz/ManageQuizDetails";
import ManageQuizList from "../pages/Admin/ManageQuiz/ManageQuizList";
import MyCourse from "../pages/Admin/MyCourse/MyCourse";
import MyCourseDetails from "../pages/Admin/MyCourse/MyCourseDetails";
import LearnerDetails from "../pages/Admin/Quiz/LearnerDetails";
import QuizDetails from "../pages/Admin/Quiz/QuizDetails";
import Categories from "../pages/Admin/setting/categories/Categories";
import Subcategories from "../pages/Admin/setting/subcategories/Subcategories";
import Tags from "../pages/Admin/setting/tags/Tags";
import Login from "../pages/Auth/login/login";
import Otp from "../pages/Auth/login/otp";
import NotFound from "../pages/NotFound";
import type { AppRoute } from "../types/global.types";
import CampaignIcon from "./_icons/CampaignIcon";
import SettingsIcon from "./_icons/SettingsIcon";

// App routes
export const APP_ROUTES: AppRoute[] = [
  {
    path: "/admin/dashboard",
    label: "Dashboard",
    icon: DashboardIcon,
    element: Dashboard,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/my-course/manage-course",
    element: ManageCourse,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/my-course/manage-course/:courseId",
    element: ManageCourse,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/my-course/manage-course/highlights/:courseId",
    element: ManageHighlights,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/my-course/manage-course/content/:courseId",
    element: ManageContent,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/my-course/manage-course/manage-quiz/:courseId/:sectionId",
    element: ManageQuizList,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/my-course/manage-course/manage-quiz/:courseId/:sectionId/details/:quizId",
    element: ManageQuizDetails,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/my-course",
    label: "My Courses",
    icon: MyCoursesIcon,
    element: MyCourse,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/my-course/:id",
    element: MyCourseDetails,
    roles: [USER_ROLES.ADMIN],
  },
  // {
  //   path: "/admin/quiz",
  //   label: "Quiz",
  //   icon: QuizIcon,
  //   element: Quiz,
  //   roles: [USER_ROLES.ADMIN],
  // },
  {
    path: "/admin/quiz/:id",
    element: QuizDetails,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/quiz/:id/:learnerId",
    element: LearnerDetails,
    roles: [USER_ROLES.ADMIN],
  },
  // {
  //   path: "/admin/earnings",
  //   label: "Earnings",
  //   icon: EarningsIcon,
  //   element: Earnings,
  //   roles: [USER_ROLES.ADMIN],
  // },
  {
    path: "/admin/campaign",
    label: "Campaign",
    icon: CampaignIcon,
    element: Campaign,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/campaign/create",
    element: ManageCampaign,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/campaign/update/:id",
    element: ManageCampaign,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/campaign/view/:viewId",
    element: ManageCampaign,
    roles: [USER_ROLES.ADMIN],
  },
  // {
  //   path: "/admin/profile",
  //   label: "Profile",
  //   icon: ProfileIcons,
  //   element: Profile,
  //   roles: [USER_ROLES.ADMIN],
  // },
  {
    path: "/admin/setting",
    label: "Setting",
    icon: SettingsIcon,
    roles: [USER_ROLES.ADMIN],
    children: [
      {
        path: "/admin/setting/categories",
        label: "Categories",
        element: Categories,
        roles: [USER_ROLES.ADMIN],
      },
      {
        path: "/admin/setting/sub-categories",
        label: "Sub Categories",
        element: Subcategories,
        roles: [USER_ROLES.ADMIN],
      },
      {
        path: "/admin/setting/tags",
        label: "Tags",
        element: Tags,
        roles: [USER_ROLES.ADMIN],
      },
    ],
  },
];

// Public routers
export const PUBLIC_ROUTES: {
  path: string;
  element: ElementType;
  name?: string;
}[] = [
  {
    path: "/login",
    element: Login,
  },
  {
    path: "/otp",
    element: Otp,
  },
  {
    path: "*",
    element: NotFound,
  },
];
